// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__t-Vq4","col":"CardReaderDesc_col__tNdTF","label":"CardReaderDesc_label__GYCoP"};